import React from 'react';
import ReactDOM from 'react-dom';

import Data from 'data';

import { getIconPath } from 'common';

import Store from 'store';
import './gametips.scss';
import { getTypeIconsPath } from 'common';
import { D3TooltipAltar, D3TooltipBuff, D3TooltipFollowerSkill, D3TooltipGem, D3TooltipItem, D3TooltipSet, D3TooltipSkill, D3TooltipStat } from 'tooltips';
import { genderString } from 'data/locale';
import classNames from 'classnames';

const bnetSlug = name => name.replace(/[^\w ]/g, "").replace(/ /g,"-").toLowerCase();
const bnetItemUrl = item => `https://eu.diablo3.com/en/item/${bnetSlug(item.name)}-${item.id}`;
const bnetGemUrl = name => `https://eu.diablo3.com/en/artisan/jeweler/recipe/${bnetSlug(name)}`;
const bnetSkillUrl = (charClass, name) => `http://eu.diablo3.com/en/class/${bnetSlug(Data.classes[charClass].name)}/active/${bnetSlug(name)}`;
const bnetFollowerSkillUrl = (charClass, name) => `http://eu.diablo3.com/en/follower/${charClass}/skill/${bnetSlug(name)}`;
const bnetPassiveUrl = (charClass, name) => `http://eu.diablo3.com/en/class/${bnetSlug(Data.classes[charClass].name)}/passive/${bnetSlug(name)}`;

const Link = ({ children, href, ...props }) => <span {...props}>{children}</span>;
const canonicalName = name => name.replace(/[^\w]/g, "").toLowerCase();
class Lookup {
  _initItems() {
    const itemByName = this._itemByName = {};
    const etherealByName = this._etherealByName = {};
    for (let item of Data.items) {
      if (!item.legacy) {
        if (item.quality === "ethereal") {
          etherealByName[canonicalName(item.name)] = item;
          if (item.defaultName) etherealByName[canonicalName(item.defaultName)] = item;
        } else {
          itemByName[canonicalName(item.name)] = item;
          if (item.defaultName) itemByName[canonicalName(item.defaultName)] = item;
        }
      }
    }
    for (let item of Data.potions) {
      itemByName[canonicalName(item.name)] = item;
      if (item.defaultName) itemByName[canonicalName(item.defaultName)] = item;
    }
    for (let item of Data.extraItems) {
      itemByName[canonicalName(item.name)] = item;
      if (item.defaultName) itemByName[canonicalName(item.defaultName)] = item;
    }
  }
  get itemByName() {
    if (!this._itemByName) this._initItems();
    return this._itemByName;
  }
  get etherealByName() {
    if (!this._etherealByName) this._initItems();
    return this._etherealByName;
  }

  get setByName() {
    if (!this._setByName) {
      const setByName = this._setByName = {};
      for (let [id, set] of Object.entries(Data.itemSets)) {
        setByName[canonicalName(set.name)] = id;
        if (set.defaultName) setByName[canonicalName(set.defaultName)] = id;
      }
    }
    return this._setByName;
  }

  get gemByName() {
    if (!this._gemByName) {
      const gemByName = this._gemByName = {};
      for (let [color, gem] of Object.entries(Data.gemColors)) {
        gem.names.forEach((name, i) => gemByName[canonicalName(name)] = [i, color]);
        if (gem.defaultNames) gem.defaultNames.forEach((name, i) => gemByName[canonicalName(name)] = [i, color]);
      }
      for (let [id, gem] of Object.entries(Data.legendaryGems)) {
        gemByName[canonicalName(gem.name)] = [id, 0];
        if (gem.defaultName) gemByName[canonicalName(gem.defaultName)] = [id, 0];
      }
    }
    return this._gemByName;
  }

  _initSkills() {
    const skillByName = this._skillByName = {};
    const skillRuneByName = this._skillRuneByName = {};
    const runeByName = this._runeByName = {};
    for (let [charClass, skills] of Object.entries(Data.skills)) {
      for (let [id, skill] of Object.entries(skills)) {
        skillByName[canonicalName(skill.name)] = {charClass, id};
        if (skill.defaultName) skillByName[canonicalName(skill.defaultName)] = {charClass, id};
        if (skill.runes) {
          for (let [rune, name] of Object.entries(skill.runes)) {
            skillRuneByName[canonicalName(`${skill.name} ${name}`)] = {charClass, id, rune};
            if (skill.defaultRunes) skillRuneByName[canonicalName(`${skill.defaultName} ${skill.defaultRunes[rune]}`)] = {charClass, id, rune};
            const cname = canonicalName(name);
            if (!runeByName[cname]) runeByName[cname] = [];
            runeByName[cname].push({charClass, id, rune});
            if (skill.defaultRunes) {
              const oname = canonicalName(skill.defaultRunes[rune]);
              if (!runeByName[oname]) runeByName[oname] = [];
              runeByName[oname].push({charClass, id, rune});
            }
          }
        }
      }
    }
    for (const [id, stat] of Object.entries(Data.stats)) {
      if (!stat.sanctified) continue;
      const skill = Data.skills[stat.class]?.[stat.skill];
      if (!skill) continue;
      skillByName[canonicalName(`Sanctified ${skill.name}`)] = {id, sanctified: true};
      if (skill.defaultName) skillByName[canonicalName(`Sanctified ${skill.defaultName}`)] = {id, sanctified: true};
    }
    if (runeByName[canonicalName('Communing with Spirits')]) {
      runeByName[canonicalName('Communicating with Spirits')] = runeByName[canonicalName('Communing with Spirits')];
    }
    if (skillRuneByName[canonicalName('Wall of Death Communing with Spirits')]) {
      skillRuneByName[canonicalName('Wall of Death Communicating with Spirits')] = skillRuneByName[canonicalName('Wall of Death Communing with Spirits')];
    }
  }

  get skillByName() {
    if (!this._skillByName) this._initSkills();
    return this._skillByName;
  }
  get skillRuneByName() {
    if (!this._skillRuneByName) this._initSkills();
    return this._skillRuneByName;
  }
  get runeByName() {
    if (!this._runeByName) this._initSkills();
    return this._runeByName;
  }

  get altarByName() {
    if (!this._altarByName) {
      const altarByName = this._altarByName = {};
      for (const [id, data] of Object.entries(Data.altar)) {
        altarByName[canonicalName(data.name)] = id;
      }
    }
    return this._altarByName;
  }

  get followerByName() {
    if (!this._followerByName) {
      const followerByName = this._followerByName = {};
      for (let [id, skill] of Object.entries(Data.followerSkills)) {
        followerByName[canonicalName(skill.name)] = id;
        if (skill.defaultName) followerByName[canonicalName(skill.defaultName)] = id;
      }
    }
    return this._followerByName;
  }

  get passiveByName() {
    if (!this._passiveByName) {
      const passiveByName = this._passiveByName = {};
      for (let [charClass, passives] of Object.entries(Data.passives)) {
        for (let [id, passive] of Object.entries(passives)) {
          passiveByName[canonicalName(passive.name)] = {charClass, id};
          if (passive.defaultName) passiveByName[canonicalName(passive.defaultName)] = {charClass, id};
        }
      }
    }
    return this._passiveByName;
  }

  get buffByName() {
    if (!this._buffByName) {
      const buffByName = this._buffByName = {};
      for (let [id, buff] of Object.entries(Data.shrineBuffs)) {
        buffByName[canonicalName(buff.name)] = {id, alt: false};
        buffByName[canonicalName(buff.altname)] = {id, alt: true};
      }
    }
    return this._buffByName;
  }
  
};

export const lookup = new Lookup();

export function ItemNode({ item }) {
  const icon = Data.itemIcons[item.realid || item.id];
  return (
    <React.Fragment>
      {!!icon && (
        <span className="d3planner-icon-wrap">
          <span className="d3planner-icon" style={{background: `url(${getTypeIconsPath(item.type)}) 0 -${1.2 * icon[0]}em no-repeat`}}/>
        </span>
      )}
      {!icon && !!item.icon && (
        <span className="d3planner-icon-wrap">
          <span className="d3planner-icon d3planner-icon-special" style={{backgroundImage: `url(${getIconPath(item.icon)})`}}/>
        </span>
      )}
      <D3TooltipItem data={item.id}>
        <Link href={bnetItemUrl(item)}>{genderString(item.name)}</Link>
      </D3TooltipItem>
    </React.Fragment>
  );
}

function SetNode({id}) {
  const set = Data.itemSets[id];
  return (
    <D3TooltipSet id={id}>
      <span className="set-name">{set.name}</span>
    </D3TooltipSet>
  );
}

function GemNode({gem}) {
  //const icon = Data.itemIcons[item.id];
  let item = Data.legendaryGems[gem[0]];
  if (item) {
    const icon = Data.itemIcons[item.id];
    return (
      <React.Fragment>
        {!!icon && (
          <span className="d3planner-icon-wrap">
            <span className="d3planner-icon" style={{background: `url(${getTypeIconsPath("gemleg")}) 0 -${1.2 * icon[0]}em no-repeat`}}/>
          </span>
        )}
        <D3TooltipGem id={gem[0]}>
          <Link href={bnetItemUrl(item)}>{item.name}</Link>
        </D3TooltipGem>
      </React.Fragment>
    );
  } else if ((item = Data.gemColors[gem[1]])) {
    const icon = Data.itemIcons[item.id];
    return (
      <React.Fragment>
        {!!icon && (
          <span className="d3planner-icon-gem" style={{background: `url(${getTypeIconsPath("gems")}) -${1.3 * gem[0]}em -${1.3 * icon[0]}em no-repeat`}}/>
        )}
        <D3TooltipGem id={gem}>
          <Link href={bnetGemUrl(item.names[gem[0]])}>{item.names[gem[0]]}</Link>
        </D3TooltipGem>
      </React.Fragment>
    );
  }
}

function SkillNode({ charClass, id, sanctified }) {
  if (sanctified) {
    const stat = Data.stats[id];
    const skill = Data.skills[stat.class][stat.skill];
    return (
      <React.Fragment>
        <span className={`d3p-skill-icon d3p-class-${stat.class}`} style={{backgroundPosition: `-${skill.col}em -${2 * skill.row}em`}}/>
        <D3TooltipStat id={id}>
          <span className="d3p-skill-sanctified">{Data.qualities.sanctified.prefix} {skill.name}</span>
        </D3TooltipStat>
      </React.Fragment>
    );
  }
  const skill = Data.skills[charClass][id];
  if (charClass === "attack") {
    return (
      <React.Fragment>
        <span className={`d3planner-icon-skill skill-icon-attack ${skill.id}`}/>
        <D3TooltipSkill charClass={charClass} skill={id}>
          <span className="skill-name">{skill.name}</span>
        </D3TooltipSkill>
      </React.Fragment>
    );
  }
  return (
    <React.Fragment>
      <span className={`d3p-skill-icon d3p-class-${charClass}`} style={{backgroundPosition: `-${skill.col}em -${2 * skill.row}em`}}/>
      <D3TooltipSkill charClass={charClass} skill={id}>
        <Link href={bnetSkillUrl(charClass, skill.name)}>{skill.name}</Link>
      </D3TooltipSkill>
    </React.Fragment>
  );
}

function AltarNode({ id }) {
  const data = Data.altar[id];
  return (
    <React.Fragment>
      <span className={classNames(`d3planner-icon-altar`, {"d3p-major": data.major, "d3p-final": data.final})} style={{backgroundPositionX: `-${data.icon}em`}}/>
      <D3TooltipAltar id={id}>
        <span>{data.name}</span>
      </D3TooltipAltar>
    </React.Fragment>
  );
}

function FollowerSkillNode({ id }) {
  const skill = Data.followerSkills[id];
  return (
    <React.Fragment>
      <span className="d3planner-icon-skill" style={{background: `url(${getIconPath(skill.icon)}) no-repeat`}}/>
      <D3TooltipFollowerSkill id={id}>
        <Link href={bnetFollowerSkillUrl(skill.class, skill.name)}>{skill.name}</Link>
      </D3TooltipFollowerSkill>
    </React.Fragment>
  );
}

function SkillRuneNode({ charClass, id, rune, separator }) {
  const skill = Data.skills[charClass][id];
  const element = Data.skilltips[charClass][id].elements[rune || "x"];
  return (
    <React.Fragment>
      <span className={`d3p-skill-icon d3p-class-${charClass}`} style={{backgroundPosition: `-${skill.col}em -${2 * skill.row}em`}}/>
      <D3TooltipSkill charClass={charClass} skill={id} rune={rune}>
        <Link href={bnetSkillUrl(charClass, skill.name)}>{skill.name}</Link>
      </D3TooltipSkill>
      {separator}
      <span className={`rune-icon rune-${rune || "x"}`}/>
      <D3TooltipSkill charClass={charClass} skill={id} rune={rune} onlyRune={true}>
        <span className={`rune-name rune-${element}`}>{skill.runes[rune]}</span>
      </D3TooltipSkill>
    </React.Fragment>
  );
}

function RuneNode({ charClass, id, rune }) {
  const skill = Data.skills[charClass][id];
  const element = Data.skilltips[charClass][id].elements[rune || "x"];
  return (
    <React.Fragment>
      <span className={`rune-icon rune-${rune || "x"}`}/>
      <D3TooltipSkill charClass={charClass} skill={id} rune={rune} onlyRune={true}>
        <span className={`rune-name rune-${element}`}>{skill.runes[rune]}</span>
      </D3TooltipSkill>
    </React.Fragment>
  );
}

function PassiveNode({ charClass, id }) {
  const passive = Data.passives[charClass][id];
  return (
    <React.Fragment>
      <span className={`d3p-passive-icon d3p-class-${charClass}`} style={{backgroundPosition: `-${passive.index}em 0`}}/>
      <D3TooltipSkill charClass={charClass} skill={id}>
        <Link href={bnetPassiveUrl(charClass, passive.name)}>{passive.name}</Link>
      </D3TooltipSkill>
    </React.Fragment>
  );
}

function BuffNode({ id, alt }) {
  const buff = Data.shrineBuffs[id];
  return (
    <React.Fragment>
      <span className="d3planner-icon-skill" style={{background: `url(${getIconPath(buff.icon)}) no-repeat`}}/>
      <D3TooltipBuff id={id}>
        <span>{alt ? buff.altname : buff.name}</span>
      </D3TooltipBuff>
    </React.Fragment>
  );
}

export const gameTipClasses = ['d3planner-item', 'd3planner-eth', 'd3planner-skill', 'd3planner-rune',
  'd3planner-skill-rune', 'd3planner-passive', 'd3planner-buff', 'd3planner-follower', 'd3planner-set'];

let _lastClass = null;
export function createTipNode(node) {
  const text = canonicalName(node.textContent);
  let data, m;
  if (node.classList.contains("d3planner-item")) {
    if ((data = lookup.itemByName[text])) {
      node.classList.add(`item-${data.quality}`);
      return <ItemNode item={data}/>;
    } else if ((data = lookup.gemByName[text])) {
      node.classList.add(Data.legendaryGems[data[0]] ? "item-legendary" : "item-magic");
      return <GemNode gem={data}/>;
    }
  } if (node.classList.contains("d3planner-eth")) {
    if ((data = lookup.etherealByName[text])) {
      node.classList.add(`item-${data.quality}`);
      return <ItemNode item={data}/>;
    }
  } else if (node.classList.contains("d3planner-skill")) {
    if ((data = lookup.skillByName[text])) {
      _lastClass = data.charClass;
      node.classList.add("d3planner-build");
      return <SkillNode {...data}/>;
    } else if ((data = lookup.altarByName[text])) {
      node.classList.add("d3planner-build");
      return <AltarNode id={data}/>
    }
  } else if (node.classList.contains("d3planner-follower")) {
    if ((data = lookup.followerByName[text])) {
      node.classList.add("d3planner-build");
      return <FollowerSkillNode id={data}/>;
    }
  } else if (node.classList.contains("d3planner-skill-rune")) {
    if ((data = lookup.skillRuneByName[text])) {
      _lastClass = data.charClass;
      node.classList.add("d3planner-build");
      return <SkillRuneNode {...data} separator=" "/>;
    } else if ((m = node.textContent.match(/^(.*\S)(\s*[,\-:]\s+)(\S.*)$/))) {
      if ((data = lookup.skillRuneByName[canonicalName(`${m[1]} ${m[3]}`)])) {
        _lastClass = data.charClass;
        node.classList.add("d3planner-build");
        return <SkillRuneNode {...data} separator={m[2]}/>;
      }
    }
  } else if (node.classList.contains("d3planner-rune")) {
    const runes = lookup.runeByName[text];
    let data = runes && runes[0];
    if (runes && runes.length > 0 && _lastClass) {
      data = runes.find(r => r.charClass === _lastClass) || runes[0]; //eslint-disable-line
    }
    if (data) {
      _lastClass = data.charClass;
      node.classList.add("d3planner-build");
      return <RuneNode {...data}/>;
    }
  } else if (node.classList.contains("d3planner-passive")) {
    if ((data = lookup.passiveByName[text])) {
      _lastClass = data.charClass;
      node.classList.add("d3planner-build");
      return <PassiveNode {...data}/>;
    }
  } else if (node.classList.contains("d3planner-buff")) {
    if ((data = lookup.buffByName[text])) {
      return <BuffNode {...data}/>;
    }
  } else if (node.classList.contains("d3planner-set")) {
    if ((data = lookup.setByName[text])) {
      return <SetNode id={data}/>;
    }
  }
}

export default function makeGameTips() {
  const store = new Store();

  function render(element, parent) {
    ReactDOM.render((
      <Store.Provider store={store}>
        {element}
      </Store.Provider>
    ), parent);
  }

  for (let node of document.querySelectorAll(gameTipClasses.map(cls => `.${cls}`).join(', '))) {
    const embed = createTipNode(node);
    if (embed) {
      render(embed, node);
    }
  }
}
